import React, { useMemo } from 'react';
import FontPreviewCard from './FontPreviewCard';

export function FontList({ fonts, loading, error, selectedFamily, onSelect }) {
  const listToRender = useMemo(() => {
    if (!Array.isArray(fonts)) return [];
    if (fonts.length <= 100) return fonts;
    return fonts.slice(0, 100);
  }, [fonts]);

  if (loading) {
    return <p className="mp-font-picker-list__status">Carregando fontes...</p>;
  }

  if (error) {
    return <p className="mp-font-picker-list__status">{error}</p>;
  }

  if (!listToRender.length) {
    return <p className="mp-font-picker-list__status">Nenhuma fonte encontrada.</p>;
  }

  return (
    <div className="mp-font-picker-list" role="listbox" aria-label="Lista de fontes">
      {listToRender.map((font) => (
        <FontPreviewCard
          key={font.family}
          font={font}
          active={selectedFamily === font.family}
          onSelect={() => onSelect(font)}
        />
      ))}
    </div>
  );
}

export default FontList;
